var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9656 8.81739C20.9656 8.62118 20.9656 8.42497 20.9519 8.23057C21.8535 7.58657 22.6316 6.78996 23.25 5.87788C22.4076 6.24512 21.514 6.486 20.5991 6.5925C21.5627 6.02458 22.2839 5.1312 22.6284 4.07871C21.7225 4.60816 20.7313 4.98134 19.6978 5.18215C19.0017 4.45365 18.0811 3.97131 17.0786 3.80975C16.0761 3.64819 15.0474 3.81641 14.1518 4.28839C13.2561 4.76037 12.5434 5.5098 12.1238 6.42074C11.7043 7.33168 11.6013 8.35336 11.8309 9.32771C9.99549 9.23701 8.19997 8.76731 6.5609 7.94907C4.92183 7.13084 3.47583 5.98237 2.31679 4.57823C1.72625 5.57858 1.545 6.76288 1.80991 7.89016C2.07483 9.01743 2.76601 10.003 3.74281 10.6463C3.00827 10.6244 2.28977 10.4293 1.64766 10.0774V10.135C1.64826 11.1844 2.01739 12.2012 2.69246 13.0132C3.36754 13.8252 4.30702 14.3823 5.35165 14.5902C4.67209 14.7727 3.95906 14.7992 3.26747 14.6676C3.56213 15.5709 4.13634 16.3609 4.90969 16.9269C5.68304 17.4929 6.61682 17.8066 7.58026 17.824C5.94567 19.0892 3.92615 19.7759 1.84694 19.7735C1.48032 19.773 1.11405 19.7514 0.75 19.7087C2.86201 21.0449 5.32031 21.7536 7.83073 21.75C16.3219 21.75 20.9656 14.8242 20.9656 8.81739Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.487fdf212a801645db625193503307d8.svg";
export { ForwardRef as ReactComponent };